import { defineChannelContract } from 'shared/channels';

/** Contract of the page and the worker for notices of stored data changes (`tableChanged`). */
export const dbChangesContract = defineChannelContract<{
  requests: {
    /** The page shows project data: the worker tells the entity channels when their tables change. */
    startListening: { request: undefined; response: void };
  };
  events: Record<never, never>;
}>('dbChangesListenerChannel');
